import Category from "./category";

const Rci = {
  Category,
};

export default Rci;
